import useMobile from "../../hooks/useMobile"
import IconButtons from "../../stories/Buttons/IconButtons"
import * as S from "./MainVideo.styled"
import BA_website_G_mo from '../../assets/images/home/BA_website_G_mo.png'
import BA_website_G_pc from '../../assets/images/home/BA_website_G_pc.png'
import PC_Thumbnail from '../../assets/images/home/main_pc_thumbnail.jpg'
import MO_Thumbnail from '../../assets/images/home/main_mo_thumbnail.jpg'

export default function MainVideo() {
  let { isMobile } = useMobile()

  const beforeOpenThumbnail = () => {
    const src = isMobile ? BA_website_G_mo : BA_website_G_pc
    return <img className="image" src={src} alt="" />
  
  }
  const mainVideoThumbnail = () => {
    const src = isMobile ? MO_Thumbnail : PC_Thumbnail
    return <img className="image" src={src} alt="" />
  }

  const mainVideoRender = () => {
    const url = isMobile
      ? 'https://player.vimeo.com/video/1074172198?autoplay=1&loop=1&muted=1&title=0&byline=0&portrait=0&background=1'
      : 'https://player.vimeo.com/video/1073114609?autoplay=1&loop=1&muted=1&title=0&byline=0&portrait=0&background=1'
    return <iframe
      src={url}
      allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
      title="baeksang_teaser_video"
    />
  }
  return (
    <S.MainVideo>
      <div className="video-content">
        <p className="description">
          1965년 시작된 최고 권위의 종합예술상
        </p>
        <div className="title nanum">
          The most prestigious<br/>
          entertainment and { isMobile && <br />}arts awards
        </div>
        <hr className="hr"/>
        {!isMobile && (
          <div className="scroll-down">
            <IconButtons
              size={33}
              icon={{
                name: 'next',
                width: 16,
                height: 16
              }}
              onClick={()=>{}}
              rounded={true}
            />Scroll down
          </div>
        )}
      </div>
      <div className="video">
        <script src="https://player.vimeo.com/api/player.js"></script>
        {/* {beforeOpenThumbnail()} */}
        {mainVideoThumbnail()}
        {mainVideoRender()}
      </div>
      
    </S.MainVideo>
  )
}